module.exports = __webpack_public_path__ + "img/icon_benefit_07.1cd20e57.svg";